export default defineAppConfig({
  theme: {
    colors: {
      primary: '#ccc'
    }
  },
  ui: {
    colors: {
      primary: 'blue',
      secondary: 'purple',
      tertiary: 'indigo',
      neutral: 'zinc'
    },
    button: {
      compoundVariants: [
        { color: 'neutral', variant: 'solid', class: 'text-muted' },
        { color: 'neutral', variant: 'outline', class: 'text-muted' },
        { color: 'neutral', variant: 'soft', class: 'text-muted' },
        { color: 'neutral', variant: 'subtle', class: 'text-muted' },
        { color: 'neutral', variant: 'ghost', class: 'text-muted' },
        { color: 'neutral', variant: 'link', class: 'text-muted' }
      ]
    }
  }
})
